(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // Lazy-hydrate collection banner videos — promote data-src → src and
  // start playback only when the banner approaches the viewport. Pause
  // when scrolled away so background tab traffic stays light.
  (function () {
    const vids = document.querySelectorAll('video[data-ash-lazy-direct][data-src]');
    if (!vids.length) return;
    if (!('IntersectionObserver' in window)) {
      vids.forEach((v) => {
        v.src = v.dataset.src;
        v.removeAttribute('data-src');
        v.play().catch(() => {});
      });
      return;
    }
    // Two-ring observer — preload early at 1200px, play/pause at 300px.
    const preloadObs = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const v = entry.target;
          if (!v.getAttribute('src') && v.dataset.src) {
            v.src = v.dataset.src;
            v.removeAttribute('data-src');
          }
          preloadObs.unobserve(v);
        }
      });
    }, { rootMargin: '1200px 0px', threshold: 0 });
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const v = entry.target;
        if (entry.isIntersecting) {
          if (!v.getAttribute('src') && v.dataset.src) {
            v.src = v.dataset.src;
            v.removeAttribute('data-src');
          }
          v.play().catch(() => {});
        } else {
          v.pause();
        }
      });
    }, { rootMargin: '300px 0px', threshold: 0.1 });
    vids.forEach((v) => { preloadObs.observe(v); io.observe(v); });
  })();

  } catch(e) { console.error(e); }
})();
})();
